package com.shadowings.gero.data.lessons.chapter12

import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter1.getUni1Content
import com.shadowings.gero.data.lessons.chapter1.getUni2Content
import com.shadowings.gero.data.lessons.chapter2.animalNames
import com.shadowings.gero.data.lessons.chapter2.foodNames
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFood2Content
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter2.humanNames
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieContent
import com.shadowings.gero.data.lessons.chapter3.vocabVarieWords
import com.shadowings.gero.data.lessons.chapter4.royalNameWordIds
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs3Content
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs1WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs2WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs3WordIds
import com.shadowings.gero.data.lessons.chapter6.getHieroVerbs4Content
import com.shadowings.gero.data.lessons.chapter6.vocabVerbs4WordIds
import com.shadowings.gero.data.lessons.chapter7.getHieroVso1Content
import com.shadowings.gero.data.lessons.chapter7.getHieroVso2Content
import com.shadowings.gero.data.lessons.chapter7.getHieroVso3Content
import com.shadowings.gero.data.lessons.chapter7.vocabVso1WordIds
import com.shadowings.gero.data.lessons.chapter7.vocabVso2WordIds
import com.shadowings.gero.data.lessons.chapter7.vocabVso3WordIds
import com.shadowings.gero.data.lessons.chapter9.getHieroVari1Content
import com.shadowings.gero.data.lessons.chapter9.getHieroVari2Content
import com.shadowings.gero.data.lessons.chapter9.vocabVari1WordIds
import com.shadowings.gero.data.lessons.chapter9.vocabVari2WordIds
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_verbi_vari_alyn_1
import gero.composeapp.generated.resources.exp_content_verbi_vari_zeta_1
import gero.composeapp.generated.resources.exp_title_hiero_verbi_vari_intro

val verbiVariWordIds = listOf(
    "APRIRE", "ARROSTIRE", "GUARDARE", "CANTARE", "CHIAMARE", "LAVORARE", "SOLLEVARE"
)

fun getHieroVerbiVariContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {

    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_hiero_verbi_vari_intro,
            content = Res.string.exp_content_verbi_vari_zeta_1,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_hiero_verbi_vari_intro,
            content = Res.string.exp_content_verbi_vari_alyn_1,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
    )

    val previous = (famousNames + foodNames + animalNames + humanNames + vocabVarieWords +
            royalNameWordIds + vocabVerbs1WordIds + vocabVerbs2WordIds + vocabVerbs3WordIds +
            vocabVerbs4WordIds + vocabVso1WordIds + vocabVso2WordIds + vocabVso3WordIds +
            vocabVari1WordIds + vocabVari2WordIds + famigliaSocietaWordIds).toHieroList(words)
    val current = verbiVariWordIds.toHieroList(words)

    return intro + current.filter { it !in previous }.toHieroExplanation(hiero, languageCode).map {
        it.copy(character = Characters.Zeta)
    }
}

fun getHieroVerbiVariQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val previousContent = getUni1Content(hiero, words, languageCode) +
            getUni2Content(hiero, words, languageCode) +
            getHieroFoodContent(hiero, words, languageCode) +
            getHieroFood2Content(hiero, words, languageCode) +
            getHieroAnimalsContent(hiero, words, languageCode) +
            getHieroHumansContent(hiero, words, languageCode) +
            getHieroVarieContent(hiero, words, languageCode) +
            getHieroVerbs1Content(hiero, words, languageCode) +
            getHieroVerbs2Content(hiero, words, languageCode) +
            getHieroVerbs3Content(hiero, words, languageCode) +
            getHieroVerbs4Content(hiero, words, languageCode) +
            getHieroVso1Content(hiero, words, languageCode) +
            getHieroVso2Content(hiero, words, languageCode) +
            getHieroVso3Content(hiero, words, languageCode) +
            getHieroVari1Content(hiero, words, languageCode) +
            getHieroVari2Content(hiero, words, languageCode) +
            getHieroFamigliaSocietaContent(hiero, words, languageCode)

    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getHieroVerbiVariContent(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = previousContent
    )
}
